import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Product from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import AppointmentSystemLanding from './components/AppointmentSystemLanding';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// 🚨 ADD THESE
import AeroLoader from './components/AeroLoader';
import { showLoader, hideLoader } from './utils/aero-loader';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    AOS.refresh();
  }, [pathname]);

  return null;
}

export default function App() {
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, []);

  // 🚨 ADD LOADER LIFECYCLE
  useEffect(() => {
    showLoader(); // show on app mount
    window.addEventListener('load', hideLoader);

    return () => window.removeEventListener('load', hideLoader);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      {/* 🚨 GLOBAL BALLISTIC LOADER */}
      <AeroLoader />

      <Navbar />
      <ToastContainer />

      <main className="flex-1">
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Product />} />
          <Route path="/:slug" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/appointmentsystem"
            element={<AppointmentSystemLanding />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
